export const loadingText = '...Loading';